import { TrackingFeature } from '../types/feature';

export const SGFeature: TrackingFeature = {
  enabledFacebookCapiV2: true,
  enabledTrackProductPageViewMoreThan3: true,
};
